<template>
  <div
    :key="`attachment-${attachment.key}`"
    :class="`${mode}-attachment-block flex pt-3 pb-2 pr-4 pl-5`">
    <div class="flex">
      <div>
        <sIcon
          :class="`${mode}-attachment-icon mt-0`"
          size="26"
          type="draft"/>
      </div>
      <div>
        <p :class="`${mode}-attachment-title`">
          {{ attachment.title }}
        </p>
        <p :class="`${mode}-attachment-size`">
          {{ getSize(attachment.size) }}
        </p>
      </div>
    </div>
    <sPopover
      ref="popover"
      placement="bottom-end"
      trigger="click">
      <sButton
        slot="reference"
        class="ml-10"
        icon="menu"
        small
        type="text"/>
      <div :class="`${mode}-attachment-menu`">
        <div :class="`${mode}-attachment-menu-item`">
          <sButton
            icon="eye"
            small
            type="text"
            @click="showDocument(attachment)">
            {{ $t('Common.ViewFile') }}
          </sButton>
        </div>
        <div :class="`${mode}-attachment-menu-item`">
          <sButton
            icon="download"
            small
            type="text"
            @click="downloadDocument(attachment)">
            {{ $t('Tenders.Download') }}
          </sButton>
        </div>
      </div>
    </sPopover>
  </div>
</template>
<script>
/**
 * Документы вопросов к поставщикам
 */
export default {
  name: 'questionAttachments',
  methods: {
    showDocument(attachment) {
      this.$refs.popover.showPopper = false
      this.$root.$emit('showDocumentView', attachment)
    },
    downloadDocument(attachment) {
      this.$refs.popover.showPopper = false

      attachment.saveFile()
    },
    getSize(length) {
      // mb
      if (length > 1024 * 1024) {
        return `${Math.round(length / (1024 * 1024))} ${this.$t('Common.Mb')}`
      } else if (length > 1024) {
        return `${Math.round(length / 1024)} ${this.$t('Common.Kb')}`
      }
      return `${length} ${this.$t('Common.bytes')}`
    },
  },
  props: {
    /**
     * Документ
     */
    attachment: {
      type: Object
    },
    mode: {
      type: String,
      validator: function (value) {
        return ['left', 'right'].indexOf(value) !== -1
      },
      default: 'left'
    }
  },
}
</script>
<style scoped lang="scss">
.right-attachment,
.left-attachment {
  &-block {
    border-radius: 8px;
    margin-top: 12px;
    max-width: 410px;
    display: flex;
    justify-content: space-between;
  }
  &-icon {
    margin: 4px 0 auto 0;
    padding-right: 10px;
  }
  &-title {
    font-size: 14px;
    margin-bottom: 0;
    max-width: 280px;
    overflow: auto;
  }
  &-size {
    padding-bottom: 12px;
    font-size: 11px;
    margin-bottom: 0;
    padding-bottom: 0;
    color: #939393;
  }
  &-menu {
    padding: 9px 15px;
  }
  &-menu-item {
    padding: 3px 0;
  }
}
.left-attachment {
  &-block {
    background: var(--green_chosen_light);
  }
}
.right-attachment {
  &-block {
    background: var(--color-main-green);
    margin-right: 0;
    margin-left: auto;
  }
}
</style>
